<template>
  <checkbox
    :label="label"
    :disabled="disabled"
    :checked="checked"
    :hint="hint" />
</template>

<script>
import Checkbox from '@/components/Checkbox'

export default {
  name: 'filter-checkbox',
  props: {
    disabled: {
      type: Boolean,
      require: true
    },
    label: {
      type: String,
      require: true
    },
    value: {
      type: [Number, String],
      require: true
    },
    limit: {
      type: [Array, Boolean],
      require: true
    },
    filter: {
      type: Array,
      require: true
    },
    hint: {
      type: String,
      require: false
    }
  },
  components: {
    Checkbox
  },
  computed: {
    checked () {
      return this.filter.indexOf(this.value) !== -1
    }
  }
}
</script>